/////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc. All rights reserved
// Written by Forge Partner Development
//
// Permission to use, copy, modify, and distribute this software in
// object code form for any purpose and without fee is hereby granted,
// provided that the above copyright notice appears in all copies and
// that both that copyright notice and the limited warranty and
// restricted rights notice below appear in all supporting
// documentation.
//
// AUTODESK PROVIDES THIS PROGRAM "AS IS" AND WITH ALL FAULTS.
// AUTODESK SPECIFICALLY DISCLAIMS ANY IMPLIED WARRANTY OF
// MERCHANTABILITY OR FITNESS FOR A PARTICULAR USE.  AUTODESK, INC.
// DOES NOT WARRANT THAT THE OPERATION OF THE PROGRAM WILL BE
// UNINTERRUPTED OR ERROR FREE.
/////////////////////////////////////////////////////////////////////

function prepareUserHubsTree() {
  $('#userHubs')
    .on('load_node.jstree, after_open.jstree', function (e, data) {
      applyJsTreeClasses();
    })
    .jstree({
      core: {
        themes: {
          icons: true
        },
        strings: {
          'Loading ...': __('treeLoadingText')
        },
        multiple: false,
        data: {
          url: '/api/forge/datamanagement',
          dataType: 'json',
          cache: false,
          data: function (node) {
            $('#userHubs').jstree(true).toggle_node(node);
            return {
              id: node.id
            };
          }
        }
      },
      types: {
        'default': {
          icon: 'icon-folder'
        },
        '#': {
          icon: 'icon-account'
        },
        'hubs': {
          icon: 'icon-folder'
        },
        'personalHub': {
          icon: 'icon-folder'
        },
        'bim360Hubs': {
          icon: 'icon-folder'
        },
        'bim360projects': {
          icon: 'icon-folder'
        },
        'a360projects': {
          icon: 'icon-folder'
        },
        'folders': {
          icon: 'icon-folder'
        },
        'items': {
          icon: 'icon-file'
        },
        'bim360documents': {
          icon: 'icon-file'
        },
        'versions': {
          icon: 'icon-radio-button'
        },
        'unsupported': {
          icon: 'icon-denied'
        }
      },
      sort: function (a, b) {
        var a1 = this.get_node(a);
        var b1 = this.get_node(b);
        var parent = this.get_node(a1.parent);
        if (parent.type === 'items') {
          // Sort by version number
          var id1 = Number.parseInt(a1.text.substring(a1.text.indexOf('v') + 1, a1.text.indexOf(':')));
          var id2 = Number.parseInt(b1.text.substring(b1.text.indexOf('v') + 1, b1.text.indexOf(':')));
          return id1 > id2 ? 1 : -1;
        } else if (a1.type !== b1.type) return a1.icon < b1.icon ? 1 : -1;
        // Types are different inside folder, so sort by icon (files/folders)
        else return a1.text > b1.text ? 1 : -1;
      },
      plugins: ['types', 'state', 'sort'],
      state: {
        key: 'autodeskHubs'
      }
    })
    .bind('activate_node.jstree', function (evt, data) {
      // Cache selected node
      app.node = data.node;

      // Reset cache
      app.issueContainerId = null;
      calendarData = {};

      // Process selection
      if (data != null && data.node != null && (data.node.type == 'versions' || data.node.type == 'bim360documents')) {
        // In case the node.id contains a "|" then split into URN & viewableId
        if (data.node.id.indexOf('|') > -1) {
          var urn = data.node.id.split('|')[1];
          var viewableId = data.node.id.split('|')[2];
          launchViewer(urn, viewableId);
        } else {
          launchViewer(data.node.id);
        }

        var nodeId = urn || data.node.id;
        var ids = getIDsFromParents(data.node.parents);

         console.log(
           '\x1b[36mSelected Node ID (urn):\x1b[37m ' + (urn || data.node.id)
         );
        // console.log('\x1b[36mSelected Hub ID:\x1b[37m ' + ids.hubId);
        // console.log('\x1b[36mSelected Project ID:\x1b[37m ' + ids.projectId);

        // Get the default text for the bookmark
        let bookmarkName = '';
        if (data.node.text) {
          bookmarkName = data.node.text;
          const leaf = $('.jstree-node.jstree-leaf[id="' + nodeId + '"]');
          if (leaf.length) {
            const parentLeaf = leaf.parents('li');
            if (parentLeaf.length) {
              const parentText = $(parentLeaf[0]).find('> a').text();
              if (parentText) {
                bookmarkName = parentText + ' ' + bookmarkName;
              }
            }
          }
        }

        // Set new data and relaod page
        return setProjectAndReload(ids.hubId, ids.projectId, nodeId, bookmarkName);
      }
    });
}

function applyJsTreeClasses() {
  $.each($('.jstree-anchor:not(.anchor-initialized)'), function (index, item) {
    item = $(item);
    if (item.find('.icon-radio-button').length) {
      item.addClass('anchor-initialized').addClass('jstree-node-clickable');
    } else {
      item.addClass('anchor-initialized');
    }
  });
}

// Get project ID and Hub ID from parents

function getIDsFromParents(parents) {
  var ret = {
    hubId: '',
    projectId: ''
  };

  $.each(parents, function (index, str) {
    // Hubs
    var regexHub = /\/hubs\/([a-z0-9\.-]+)/;
    var matchHub = regexHub.exec(str);
    if (matchHub && matchHub[1]) {
      ret.hubId = matchHub[1];
    }

    // Projects
    var regexProj = /\/projects\/([a-z0-9\.-]+)/;
    var matchProj = regexProj.exec(str);
    if (matchProj && matchProj[1]) {
      ret.projectId = matchProj[1];
    }
  });

  return ret;
}
